import { render, staticRenderFns } from "./BlogArea.vue?vue&type=template&id=dcc6c930&scoped=true&"
import script from "./BlogArea.vue?vue&type=script&lang=js&"
export * from "./BlogArea.vue?vue&type=script&lang=js&"
import style0 from "./BlogArea.vue?vue&type=style&index=0&id=dcc6c930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc6c930",
  null
  
)

export default component.exports